import React from "react";

interface Props {
    children: React.ReactNode;
}

const FlyoutContent = ({ children }: Props) => (
    <div data-test="flyout-content" className="relative px-2 flex-grow overflow-y-auto">
        {children}
    </div>
);

export default FlyoutContent;
